// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import HomeOutlinedSvg from "@ant-design/icons-svg/es/asn/HomeOutlined";
import AntdIcon from '../components/AntdIcon';

var HomeOutlined = function HomeOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: HomeOutlinedSvg
  }));
};

HomeOutlined.displayName = 'HomeOutlined';
export default React.forwardRef(HomeOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/HomeOutlined.js
// module id = 1317
// module chunks = 0